<template>
	<div class="sbw-detail-container">
		<!--头部-->
		<div class="jc-page-header">
			<el-page-header show-back-icon :title="$t('sbw.text.sbw')" @back="jumpToUp()" class="relative">
				<template slot="content">
					<span class="long-name" :title="gridData.name">
						{{ gridData.name }}
					</span>
					<div class="jc-list__header--right jc-box-action">
						<a :href="Config.SBW_HELP_URL" target="_blank">{{ $t('sbw.help.doc') }}</a>
						<!--操作-->
						<drop-down-operation :operations="availableOperatesArray" @clickSelectItem="selectOps"
							:buttonTitle="$t('privateNetwork.operate')">
						</drop-down-operation>
					</div>
				</template>
			</el-page-header>
		</div>
		<div class="jc-page-content">
			<el-tabs type="border-card" v-model="tabName" @tab-click="changeTab">
				<!--资源信息-->
				<el-tab-pane :disabled="tabName === 'source'" :label="$t('detail.text.sourceInfo')" name="source">
					<!--基本信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list jc-datashow-list-inline align-left">
								<el-row :gutter="20">
									<el-col :span="8">
										<!--ID-->
										<el-form-item :label="$t('detail.text.id') | withColon">
											<p>
												<span>{{ gridData.bandwidthPackageId | maybeEmpty }}</span>
                        <copy-value :copyVal="`${gridData.bandwidthPackageId}`"></copy-value>
												<!-- <span @mouseout="copyHover = false">
													<el-button :disabled="gridData.bandwidthPackageId === undefined"
														v-clipboard:copy="gridData.bandwidthPackageId"
														v-clipboard:success="copyToClipboard" v-clipboard:error="failToCopy"
														id="copy-button" type="text" icon="el-icon-document-copy">
													</el-button>
												</span> -->
											</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--名称-->
										<el-form-item :label="$t('privateNetInstance.name') | withColon"
											class="edit-jc-form">
											<span :title="gridData.name" class="sbw-name">
												{{ gridData.name | maybeEmpty }}
											</span>
											<el-popover trigger="click" visible-arrow="false" :offset="0"
												placement="left-start" :width="300" :value="showEditName"
												v-if="showEditName" ref="editValue">
												<edit-value :inputVal="gridData.name" v-if="showEditName"
													@sureEdit="editName" :type="'text'" :inputValRule="rules.name"
													:showEditDes.sync="showEditName"
													:popTitle="$t('privateNetwork.editName')">
												</edit-value>
											</el-popover>
											<el-button type="text" icon="jc-icon-edit" @click="showEditName = true"
												v-popover:editValue>
											</el-button>
											<div class="jc-colude-mask" v-if="showEditName"></div>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--地域-->
										<el-form-item :label="$t('create.text.region') | withColon">
											<p>{{ regionName | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--可用区-->
										<el-form-item :label="$t('list.region') | withColon">
											<p>{{ $t('eip.text.allAz') }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--线路-->
										<el-form-item :label="$t('eip.text.line') | withColon" class="editDescription">
											<span class="desc-span">
												{{ gridData.lineTypeName | maybeEmpty }}
											</span>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--带宽-->
										<el-form-item :label="$t('eip.text.bandwidthLimit') | withColon">
											<span>{{ gridData.bandwidth ? gridData.bandwidth + 'Mbps' : '--' }}</span>
											<span>
												{{ $t('eip.text.independentBandwidth') }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!-- 标签 -->
										<el-form-item :label="$t('listPage.text.tags') | withColon" class="edit-jc-form">
											<span class="instance-name" :title="gridData.tagPairs">{{ gridData.tagPairs |
												maybeEmpty }}</span>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
					<el-divider></el-divider>
					<!--计费信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('eip.text.billInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list jc-datashow-list-inline align-left">
								<el-row :gutter="20">
									<el-col :span="8">
										<!--计费类型-->
										<el-form-item :label="$t('detail.text.billingType') | withColon">
											<p>{{ gridData.chargeModeName | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--申请时间-->
										<el-form-item :label="$t('eip.text.applyTime') | withColon">
											<p>{{ gridData.charge ? gridData.charge.chargeStartTime : '' | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<!--到期时间（计费类型为包年包月时显示）-->
									<el-col :span="8" v-if="gridData.chargeMode
										=== ChargeModeConstant.PREPAID_BY_DURATION">
										<el-form-item :label="$t('detail.text.expireTime') | withColon">
											<p>{{ gridData.charge ? gridData.charge.chargeExpiredTime : '' | maybeEmpty }}
											</p>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
				</el-tab-pane>
				<!--共享带宽IP-->
				<el-tab-pane :disabled="tabName === 'sbwIp'" :label="$t('sbw.text.sharedBandwidthIP')" name="sbwIp">
					<span class="addip-button">
						<el-tooltip
							:disabled="!this.disableByChargeStatus && gridData.ipCount < SbwAddIpMaxCount && gridData.chargeStatus !== ''"
							:content="gridData.chargeStatus === '' ? $t('eip.help.noChargeInfo') : this.disableByChargeStatus ? $t('privateNetInstance.operations.overdueTip') : $t('sbw.help.addIpTip')"
							placement="bottom" effect="dark">
							<label>
								<el-button type="primary" @click="openAddIpDialog()"
									:disabled="this.disableByChargeStatus || gridData.ipCount >= SbwAddIpMaxCount || gridData.chargeStatus === ''">
									{{ $t('sbw.operations.addip.name') }}
								</el-button>
							</label>
						</el-tooltip>
					</span>
					<el-table :data="eipTableData" class="alias-ip-tab-table" v-loading="eipTableDataLoading">
						<!--IP ID/地址-->
						<el-table-column :label="$t('sbw.text.idOrAddress')" prop="elasticIpId">
							<template slot-scope="scope">
								<span>{{ scope.row.elasticIpId | maybeEmpty }}</span>
								<p>{{ scope.row.elasticIp | maybeEmpty }}</p>
							</template>
						</el-table-column>
						<!--IP类型-->
						<el-table-column :label="$t('detail.text.ipType')" prop="source">
							<template slot-scope="scope">
								<span>{{ $t('eip.text.eip') }}</span>
							</template>
						</el-table-column>
						<!--操作-->
						<el-table-column :label="$t('listPage.tableLabel.operation')" prop="cidr">
							<template slot-scope="scope">
								<a href="javascript:void(0)" class="cps-select-form-item"
									@click="selectOpts(SbwOperationConstant.REMOVESHARED, scope.row, 'removeshared', OverdueConstantArray.includes(gridData.chargeStatus))"
									:class="{ 'cps-dropdown-disabled': OverdueConstantArray.includes(gridData.chargeStatus) }">
									{{ $t('eip.text.removeShareBandwidth') }}
								</a>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<!--监控-->
				<el-tab-pane :label="$t('detail.text.monitor')" name="performanceMonitor"
					:disabled="tabName === 'performanceMonitor'">
					<performance-monitor v-if="tabName === 'performanceMonitor'" :regionId="region"
						:resourceId="bandwidthPackageId" :metrics="metrics"
						:service-code="ServiceCodeConstant.CPSBW"></performance-monitor>
				</el-tab-pane>
				<div v-if="tabName === 'sbwIp' && total > 0" ref="footer"
					class="jc-page-footer-detail block jc-container-table-actionBar">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</el-tabs>
		</div>
		<div v-if="copyHover" class="jc-tooltip__popper is-dark copy-success" x-placement="bottom">
			{{ $t('detail.text.copySuccess') }}
			<div class="popper__arrow copy-success-arrow"></div>
		</div>
		<!--添加Ip-->
		<add-ip v-if="addIpDialogVisible" :dialog-visible.sync="addIpDialogVisible" :detail-data="gridData" :region="region"
			@refresh="refreshDetail">
		</add-ip>
		<modify-bandwidth :dialog-visible="modifyDialogVisible" @ifDialogVisible="syncModifyDialogVisibleData"
			:detailData="gridData" pageType="SBW">
		</modify-bandwidth>
		<!--编辑标签-->
		<jcb-tag-edit :visible.sync="editTagDialogVisible" :service-code="ServiceCodeConstant.CPSBW"
			:region-id="gridData.region ? gridData.region : ''"
			:resource-ids="gridData.bandwidthPackageId ? [gridData.bandwidthPackageId] : []" @complete="refreshDetail">
		</jcb-tag-edit>
		<!--删除-->
		<delete-sbw :dialog-visible="deleteDialogVisible" @ifDialogVisible="syncDeleteDialog" :detail-data="currentRow"
			@refresh="handleDelete">
		</delete-sbw>
	</div>
</template>

<script>
import {
	ServiceCodeConstant,
	ChargeModeConstant,
	SbwOperationConstant,
	OverdueConstantArray,
	ArrearConstantArray,
	ChargeModeMap,
	SbwAddIpMaxCount
} from '@/common/Constants';
import { getDetailbandwidthPackages, modifyBandwidthPackagesName, getListElasticIps } from '@/api/sbw/detail/actions';
import EditValue from '@/components/privateNetwork/EditValue';
import copyValue from '@/components/privateNetwork/CopyValue';
import AddIp from '@/components/sbw/addIp/AddIp';
import DeleteSbw from '@/components/sbw/deleteSbw/DeleteSbw';
import ModifyBandwidth from '@/components/common/modifyBandwidth/ModifyBandwidth';
import { operations } from '@/common/SbwPopHelper';
import { isEmptyObject } from '@/common/tool';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import PerformanceMonitor from '@/components/common/PerformanceMonitor/Monitor';
import { guid } from "@/common/tool";
import { getYMD } from '@/common/dataHelper';

export default {
	components: {
		EditValue,
		copyValue,
		ModifyBandwidth,
		AddIp,
		DeleteSbw,
		dropDownOperation,
		PerformanceMonitor
	},
	data() {
		// 验证实例名称
		const valName = (rule, value, callback) => {
			const reg = new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$');
			if (!reg.test(value)) {
				callback(new Error(this.$t('create.help.instanceNameRule')));
			} else {
				callback();
			}
		};
		this.ServiceCodeConstant = ServiceCodeConstant;
		this.SbwOperationConstant = SbwOperationConstant;
		this.ChargeModeConstant = ChargeModeConstant;
		this.ChargeModeMap = ChargeModeMap;
		this.ArrearConstantArray = ArrearConstantArray;
		this.OverdueConstantArray = OverdueConstantArray;
		this.SbwAddIpMaxCount = SbwAddIpMaxCount;
		this.metrics = [
			{ include: ['cpsbw.ingress.bandwidth'], guid: guid() },
			{ include: ['cpsbw.egress.bandwidth'], guid: guid() },
			{ include: ['cpsbw.ingress.pkgsrate'], guid: guid() },
			{ include: ['cpsbw.egress.pkgsrate'], guid: guid() },
			{ include: ['cpsbw.ingress.usage'], guid: guid() },
			{ include: ['cpsbw.egress.usage'], guid: guid() },
			{ include: ['cpsbw.ingress.bytes'], guid: guid() },
			{ include: ['cpsbw.egress.bytes'], guid: guid() },
			{ include: ['cpsbw.ingress.pkgdroprate'], guid: guid() },
			{ include: ['cpsbw.egress.pkgdroprate'], guid: guid() },
		];
		return {
			showEditDes: false,
			showEditName: false,
			rules: {
				name: [
					{
						required: true,
						message: this.$t('privateNetwork.nameNotNull'),
					},
					{
						validator: valName,
					}
				]
			},
			clientToken: Normal.getClientToken(),
			elasticIpId: '',
			// 支持的操作
			operatesArr: [
				'ADDIP', //添加IP
				'MODIFY', // 修改带宽
				'RENEW', // 续费
				'EDITTAG',//编辑标签
				'DELETE', // 删除
			],
			// 当前共享带宽支持的操作
			availableOperatesArray: [],
			selectOperate: '1',
			gridData: {},
			descriptionFlag: false,
			editObj: {
				editName: '',
				editDescription: ''
			},
			tabName: 'source',
			region: '',
			regionName: '',
			copyHover: false,
			// 子网对应的云物理服务器列表
			subnetInstanceListData: [],
			// 云物理服务器tab页loading状态
			tableListLoading: false,
			// 云物理服务器个数
			// 修改带宽弹框是否可见
			modifyDialogVisible: false,
			// 编辑标签弹框是否可见
			editTagDialogVisible: false,
			// 删除EIP弹框是否可见
			deleteDialogVisible: false,
			// 当前行所有数据
			currentRow: {},
			// 添加IPdialog
			addIpDialogVisible: false,
			// 共享带宽IPTab页eip列表数据
			eipTableData: [],
			// eip列表loading状态
			eipTableDataLoading: false,
			total: 0,
			pageSizes: [20, 50, 100],
			pageSize: 20,
			currentPage: 1,
		};
	},
	computed: {
		computedTargetIp: () => {
			return function (data) {
				let targetIp = data.targetIp;
				let aliasIp = data.aliasIp;
				if (targetIp) {
					return `${targetIp}(${this.$t('subnet.text.privateIp')})`
				}
				if (aliasIp) {
					return `${aliasIp}(${this.$t('subnet.text.ipAlias')})`
				}
				return '--'
			}
		},
		// 判断操作是否应该因不正确的计费状态而被禁用
		disableByChargeStatus() {
			if (OverdueConstantArray.includes(this.gridData?.charge?.chargeStatus)) {
				return true;
			}
			return false;
		},
	},
	watch: {},
	mounted() {
		this.bandwidthPackageId = this.$route.params.id;
		this.region = this.$route.params.region;
		this.az = this.$route.params.az;
		this.regionName = this.$route.query.regionName;
		this.tabName = this.$route.query.tabName;
		// 获取资源信息tab页数据
		this.getSourceData();
		this.getEipList('refresh');
	},
	methods: {
        handleDelete () {
            this.$router.push({
                path: '/sbw/list',
            });
        },
		changeTab(tab) {
			if (tab.name === 'sbwIp') {
				this.getEipList()
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getEipList();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getEipList();
		},
		// 编辑名称
		editName(value) {
			this.renew = false;
			const params = {
				region: this.region,
				bandwidthPackageId: this.bandwidthPackageId,
				name: value
			};
			modifyBandwidthPackagesName(params)
				.then((res) => {
					if (res.data) {
						this.gridData.name = res.data.bandwidthPackage.name;
					}
				}).finally(() => {
					this.renew = true;
				});
		},
		syncDeleteDialog(data) {
			this.deleteDialogVisible = data;
		},
		getSourceData() {
			let params = {
				bandwidthPackageId: this.bandwidthPackageId,
				region: this.region
			}
			getDetailbandwidthPackages(params).then(res => {
				this.gridData = res.data.bandwidthPackage;
				// 格式化计费信息数据
				if (isEmptyObject(this.gridData.charge)) {
					this.gridData.chargeStatus = '';
					this.gridData.chargeModeName = '';
					this.gridData.chargeMode = '';
				} else {
					this.gridData.chargeStatus = this.gridData.charge.chargeStatus;
					this.gridData.chargeModeName
						= this.ChargeModeMap[this.gridData.charge.chargeMode.toUpperCase()];
					this.gridData.chargeMode = this.gridData.charge.chargeMode
				}
				let tags = this.gridData.tags;
				this.gridData.tagPairs = '';
				if (tags && tags.length > 0) {
					for (const tag of tags) {
						this.gridData.tagPairs += `${tag.key}:${tag.value},`;
					}
					this.gridData.tagPairs = this.gridData.tagPairs.substring(0, this.gridData.tagPairs.length - 1);
				}
				this.initOperates();
				// this.getUserIfVip({ region: this.gridData.region }).then(
				// 	this.initOperates
				// );
			}).catch(error => {
				console.log(error)
			});
		},
		// 获取当前共享带宽下已添加的弹性公网列表
		getEipList(type) {
			if (type === 'refresh') {
				this.currentPage = 1;
				this.pageSize = 20;
			}
			this.eipTableDataLoading = true;
			const params = {
				region: this.region,
				bandwidthPackageIds: this.bandwidthPackageId,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
				hasJoinBandwidthPackage: 'yes'
			};
			getListElasticIps(params)
				.then((res) => {
					this.eipTableData = res.data.elasticIps;
					this.total = res.data.totalCount;
				})
				.catch()
				.finally(() => {
					this.eipTableDataLoading = false;
				});
		},
		// 添加Ip等操作后刷新详情
		refreshDetail() {
			this.getSourceData();
			this.getEipList('refresh');
		},
		// 操作下拉选初始化，调整带宽、续费
		initOperates() {
			this.availableOperatesArray = this.operatesArr.map((key) => {
				const { name } = this.$t(`sbw.operations.${key.toString().toLowerCase()}`);
				const item = {
					value: SbwOperationConstant[key],
					operateName: name,
					ifShow: true,
					disabled: false,
					tip: ''
				};
				if (!this.gridData.chargeStatus) {
					item.disabled = true;
					item.tip = this.$t('eip.help.noChargeInfo');
					return item
				}
				if (key === 'DELETE' && this.gridData.chargeMode === this.ChargeModeConstant.PREPAID_BY_DURATION) {
					item.disabled = true;
					item.tip = this.$t('eip.help.paidByDurationDeleteNotAllowed');
				}
				if (key === 'DELETE' && this.gridData.status === 'associate') {
					item.disabled = true;
					item.tip = this.$t('eip.help.boundDeleteNotAllowed');
				}
				if (key === 'DELETE' && this.gridData.ipCount > 0) {
					item.disabled = true;
					item.tip = this.$t('sbw.help.deleteSbwTip');
				}
				if (key === 'DELETE' && this.gridData.chargeMode === this.ChargeModeConstant.ENHANCED_BY_DURATION && !this.isExceedMonth(this.gridData)) {
					item.disabled = true;
					item.tip = this.$t('sbw.help.unExceedMonth');
				}
				if (this.gridData.ipCount >= this.SbwAddIpMaxCount && key
					=== 'ADDIP') {
					item.disabled = true;
				}
				if (this.gridData.ipCount >= this.SbwAddIpMaxCount && key
					=== 'ADDIP') {
					item.tip = this.$t('sbw.help.addIpTip');
				}
				if (key === 'RENEW' && this.gridData.chargeMode === this.ChargeModeConstant.ENHANCED_BY_DURATION) {
					item.disabled = true;
					item.tip = this.$t('sbw.help.payByEnhancedNotAllowedRenew');
				}
				if (this.disableByChargeStatus && key !== 'RENEW' && key !== 'DELETE' && key !== 'EDITTAG') {
					item.disabled = true;
					item.tip = this.$t('privateNetInstance.operations.overdueTip');
				}
				if (!this.gridData.chargeStatus) {
					item.disabled = true;
					item.tip = this.$t('eip.help.noChargeInfo');
					return item;
				}
				return item;
			});
		},
		jumpToUp() {
			this.$router.push({
				name: 'SbwList',
				params: { region: this.region }
			});
		},
		selectOps(item) {
			switch (item) {
				case SbwOperationConstant.ADDIP: {
					if (item.disabled) {
						return false;
					}
					this.addIpDialogVisible = true;
					break;
				}
				case SbwOperationConstant.MODIFY: {
					if (item.disabled) {
						return false;
					}
					this.modifyDialogVisible = true;
					break;
				}
				case SbwOperationConstant.RENEW: {
					if (item.disabled) {
						return false;
					}
					operations(SbwOperationConstant.RENEW, this, this.gridData, 'detail');
					break;
				}
				case SbwOperationConstant.EDITTAG: {
					if (item.disabled) {
						return false;
					}
					this.editTagDialogVisible = true;
					break;
				}
                // 删除共享带宽
				case SbwOperationConstant.DELETE: {
					if (item.disabled) {
						return false;
					}
					this.currentRow = this.gridData;
					this.deleteDialogVisible = true;
					break;
				}
			}
		},
		copyToClipboard() {
			this.copyHover = true;
		},
		failToCopy() {
			console.log('Failed to copy texts');
		},
		// 同步修改带宽子组件传来的dialog是否显示
		syncModifyDialogVisibleData(data) {
			this.modifyDialogVisible = data;
		},
		// 移出共享带宽操作
		selectOpts(caseOps, cps, operate, disabled) {
			if (disabled) {
				return;
			}
			cps.bandwidthPackageId = this.bandwidthPackageId;
			operations(caseOps, this, cps, 'detail');
		},
		openAddIpDialog() {
			if (this.disableByChargeStatus || this.gridData.ipCount >= this.SbwAddIpMaxCount || !this.gridData.chargeStatus) {
				return
			}
			this.addIpDialogVisible = true
		},
		// 计算时间差值有没有超过1个自然月
		isExceedMonth(row) {
			let [createTime] = row.createTime.split(/\s+/);
			let [endTime] = getYMD(Date.now()).split(/\s+/);
			let startArr = createTime.split('-').map(Number);
			let endArr = endTime.split('-').map(Number);
			let [year, month] = endArr.map((n, i) => n - startArr[i]);
			if (year > 0) {
				return true
			}
			if (month > 0) {
				return true
			}
			return false
		}
	}
};
</script>

<style lang="scss">
@import 'style';
@import '~@/assets/scss/detailCommon.scss';
</style>



// WEBPACK FOOTER //
// src/views/sbw/detail/Detail.vue